import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    flightSchedule: null,
    fareDetails: null,
    flightId: null,
    date: null,
    supplierCode: null,
    xmlKey: null
}

let flightSchedule = [];
let fareDetails = [];
let date = [];
let supplierCode = [];
let flightId = [];
let xmlKey = null;

const reducer = (state=initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_STACK_FLIGHT:
            if(action.flightType === "onward") {
                flightSchedule[0] = action.flightSchedule;
                fareDetails[0] = action.fareDetails;
                date[0] = action.date;
                supplierCode[0] = action.supplierCode;
                flightId[0] = action.flightId;
                xmlKey = action.xmlKey;
            } else {
                flightSchedule[1] = action.flightSchedule;
                fareDetails[1] = action.fareDetails;
                date[1] = action.date;
                supplierCode[1] = action.supplierCode;
                flightId[1] = action.flightId;
                xmlKey = action.xmlKey;
            }

            return updateObject(state, {flightSchedule: flightSchedule, fareDetails: fareDetails, date: date, supplierCode: supplierCode, flightId: flightId, xmlKey: xmlKey});
        case actionTypes.RESET_STACK_FLIGHT:
            flightSchedule = [];
            fareDetails = [];
            date = [];
            supplierCode = [];
            flightId = [];
            return updateObject(state, {flightSchedule: flightSchedule, fareDetails: fareDetails, date: date, flightId: flightId, supplierCode: supplierCode});
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/stackDepartureTuple.js